import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import Table from 'antd/lib/table';
import React from 'react';
import { defaultTablePagination } from '../../../../../config/constants';
import { translations } from '../../../../../config/translations';
import { ActionType, ModuleName } from '../../../../../core/models/enum';
import { authorizeAction } from '../../../../../helpers/CheckPermissionHelper';
import { getDefaultFilter, getSearchFilter } from '../../../../../helpers/FilterHelper';
import { showConfirm } from '../../../../../helpers/NotificationHelper';
import { getDefaultComparer } from '../../../../../helpers/SortHelper';
import { getTableLocale } from '../../../../../helpers/TableHelper';
import { CooperatorContactVm } from '../../../../../utils/api';
import { Props } from './index';

interface State {
    allowUpdate: boolean;
    allowDelete: boolean;
}

class CooperatorContactsTable extends React.Component<Props, State> {
    public constructor(props: Props) {
        super(props);

        this.state = {
            allowUpdate: authorizeAction(
                props.userProfile,
                ModuleName.Cooperators,
                ActionType.Update
            ),
            allowDelete: authorizeAction(
                props.userProfile,
                ModuleName.Cooperators,
                ActionType.Delete
            ),
        };
    }

    public render(): React.ReactElement {
        const { cooperatorContacts, onUpdate, onDelete } = this.props;
        const { allowUpdate, allowDelete } = this.state;

        const columns = [
            {
                title: translations.cooperators.name,
                dataIndex: 'name',
                ...getSearchFilter(),
                onFilter: getDefaultFilter('name'),
                sorter: getDefaultComparer('name'),
            },
            {
                title: translations.cooperators.email,
                dataIndex: 'email',
                ...getSearchFilter(),
                onFilter: getDefaultFilter('email'),
                sorter: getDefaultComparer('email'),
            },
            {
                title: translations.cooperators.phone,
                dataIndex: 'phone',
                ...getSearchFilter(),
                onFilter: getDefaultFilter('phone'),
                sorter: getDefaultComparer('phone'),
            },
            {
                title: translations.cooperators.address,
                dataIndex: 'address',
                ...getSearchFilter(),
                onFilter: getDefaultFilter('address'),
                sorter: getDefaultComparer('address'),
            },
            {
                title: translations.cooperators.city,
                dataIndex: 'cityName',
                ...getSearchFilter(),
                onFilter: getDefaultFilter('cityName'),
                sorter: getDefaultComparer('cityName'),
            },
            {
                title: translations.cooperators.country,
                dataIndex: 'countryName',
                ...getSearchFilter(),
                onFilter: getDefaultFilter('countryName'),
                sorter: getDefaultComparer('countryName'),
            },
            {
                title: translations.general.actions,
                key: 'actions',
                width: 100,
                align: 'left',
                render: (value: CooperatorContactVm): React.ReactElement => (
                    <>
                        {allowUpdate && (
                            <EditOutlined
                                onClick={() => {
                                    onUpdate(value.id);
                                }}
                            />
                        )}
                        {allowDelete && (
                            <DeleteOutlined
                                onClick={() =>
                                    showConfirm(
                                        () => onDelete(value.id),
                                        translations.cooperators.contacts.deleteConfirm,
                                        translations.general.delete,
                                        true
                                    )
                                }
                                className="red-5"
                                style={{ marginLeft: 10 }}
                            />
                        )}
                    </>
                ),
            },
        ];

        return (
            <Table
                locale={getTableLocale()}
                columns={columns}
                dataSource={cooperatorContacts}
                rowKey={(record: CooperatorContactVm): string => record.id?.toString()}
                pagination={defaultTablePagination}
                bordered
                size="small"
            />
        );
    }
}

export default CooperatorContactsTable;
